/* eslint-disable */
if (!customElements.get('wishlist-button')) {
  customElements.define(
    'wishlist-button',
    class wishlistButton extends HTMLElement {
      constructor () {
        super()
      }

      connectedCallback () {
        this.setupEventListeners()

        const savedWishlist = localStorage.getItem('swym-products')

        if (savedWishlist) {
          const wishlist = JSON.parse(savedWishlist).all
          const isWishlisted = wishlist.some(
            product => product.epi === parseInt(this.variantId, 10)
          )
          if (isWishlisted) {
            this.setAttribute('data-wishlist-status', 'added')
          }
        }
      }

      setupEventListeners () {
        const button = this.querySelector('button') || this

        button.addEventListener('click', e => {
          e.preventDefault()
          e.stopPropagation()
          if (this.wishlistStatus === 'added') {
            this.removeFromWishlist()
          } else {
            this.addToWishlist()
          }
        })
      }

      addToWishlist () {
        if (!window._swat || typeof window._swat.addToWishList !== 'function') {
          console.error('window._swat or its addToWishList method is not defined.')
          return
        }

        window._swat.addToWishList(
          {
            epi: parseInt(this.variantId, 10),
            du: this.productUrl,
            empi: parseInt(this.productId, 10)
          },
          () => {
            const customEvent = new CustomEvent('wishlist:updated')
            window.dispatchEvent(customEvent)
            this.setAttribute('data-wishlist-status', 'added')
          }
        )
      }

      removeFromWishlist () {
        if (!window._swat || typeof window._swat.removeFromWishList !== 'function') {
          console.error('window._swat or its removeFromWishList method is not defined.')
          return
        }

        window._swat.removeFromWishList(
          {
            epi: parseInt(this.variantId, 10),
            du: `${this.productUrl}?variant=${this.variantId}`,
            empi: parseInt(this.productId, 10)
          },
          () => {
            const customEvent = new CustomEvent('wishlist:updated')
            window.dispatchEvent(customEvent)
            this.removeAttribute('data-wishlist-status')
          }
        )
      }

      get variantId () {
        return this.dataset.variantId
      }

      get productId () {
        return this.dataset.productId
      }

      get productUrl () {
        return this.dataset.productUrl
      }

      get wishlistStatus () {
        return this.dataset.wishlistStatus
      }
    }
  )
}
/* eslint-enable */
